import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    fetched: false,
    savingInProgress: false,
    order_system_statuses: [],
    order_shop_statuses: [],
    order_statuses: [],
    bid_stages: [],
    order_payments_statuses: [],
      /*
    order_statuses: {
      system: [],
      shop: [],
      payments: []
    },
    */
    order_parts_statuses: [],
    order_repairtimes_statuses: []
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    removeShopOrderStatusFromState(state, id) {
      let shop = [];
      Object.entries(state.order_statuses).forEach(item => {
        if( ! (Number(item[1].id) === Number(id) && item[1].system !== true)) {
          shop.push(item[1]);
        }
      });
      Vue.set(state, 'order_statuses', shop);
    },
    removeShopOrderPartStatusFromState(state, id) {
      let shop = [];
      Object.entries(state.order_parts_statuses).forEach(item => {
        if ( ! (Number(item[1].id) === Number(id) && item[1].system !== true)) {
          shop.push(item[1]);
        }
      });
      Vue.set(state, 'order_parts_statuses', shop);
    },
    removeBidStageFromState(state, id) {
      let shop = [];
      Object.entries(state.bid_stages).forEach(item => {
        if ( ! (Number(item[1].id) === Number(id) && parseInt(item[1].is_system) !== 1)) {
          shop.push(item[1]);
        }
      });
      Vue.set(state, 'bid_stages', shop);
    },
    removeShopOrderRepairtimeStatusFromState(state, id) {
      let shop = [];
      Object.entries(state.order_repairtimes_statuses).forEach(item => {
        if ( ! (Number(item[1].id) === Number(id) && item[1].system !== true)) {
          shop.push(item[1]);
        }
      });
      Vue.set(state, 'order_repairtimes_statuses', shop);
    },
  },
  actions: {
    async shopStatusUpdate({commit, state, dispatch}, payload) {
      updateField(state, {path: 'savingInProgress', value: true});
      let type;
      switch (payload.type) {
        case 'bid_stage':
          type = 'bid_stages'
          break;
        case 'shop_order_status':
          type = 'order_statuses'
          break;
        case 'shop_order_part_status':
          type = 'order_parts_statuses'
          break;
        case 'shop_order_repairtime_status':
          type = 'order_repairtimes_statuses'
          break;
      }
      return await axios.put(this._vm.$apiURL + '/statuses/' + payload.id + '?type=' + payload.type,
          state[type].filter(status => Number(status.id) === Number(payload.id) && status.system!==true)[0])
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.operation_success'));
          return true;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        }).finally(() => {
          updateField(state, {path: 'savingInProgress', value: false});
        })
    },
    shopStatusStore({commit, state, dispatch}, payload) {
      updateField(state, {path: 'savingInProgress', value: true});
      return axios.post(this._vm.$apiURL + '/statuses?type=' + payload.type, payload.status)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.success_add'));
          return response.data.id;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'savingInProgress', value: false});
        })
    },
    async statusesGet({commit, state, dispatch}) {
      updateField(state, {path: 'fetched', value: false});
      return await axios.get(this._vm.$apiURL + '/statuses')
        .then((response) => {
          updateField(state, {path: 'order_statuses', value: response.data.orders});
          updateField(state, {path: 'bid_stages', value: response.data.bids});
          updateField(state, {path: 'order_payments_statuses', value: response.data.order_payments});
          updateField(state, {path: 'order_parts_statuses', value: response.data.order_parts});
          updateField(state, {path: 'order_repairtimes_statuses', value: response.data.order_repairtimes});
          updateField(state, {path: 'fetched', value: true});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
    },
    shopStatusRemove({commit, state, dispatch}, payload) {
      this._vm.$confirm({
        title: this._vm.i18n.t('common.confirm'),
        text: this._vm.i18n.t('common.confirm_remove'),
        cancelText: this._vm.i18n.t('common.no'),
        acceptText: this._vm.i18n.t('common.yes'),

      }).then(y => {
        return axios.delete(this._vm.$apiURL + '/statuses/' + payload.id + '?type=' + payload.type,
          {
            id: payload.id
          })
          .then(response => {
            if (response.data.status === 'success') {
              switch (payload.type) {
                case 'shop_order_status':
                  commit('removeShopOrderStatusFromState', payload.id);
                  break;
                case 'shop_order_part_status': //order_part_shop_status
                  commit('removeShopOrderPartStatusFromState', payload.id);
                  break;
                case 'bid_stage': //order_part_shop_status
                  commit('removeBidStageFromState', payload.id);
                  break;
              }

              this._vm.$inform(this._vm.i18n.t('common.success_remove'))
            }
          })
          .catch(error => {
            dispatch('common/showError', {'error': error}, {root: true});
          });
      }).catch(n => {
      });
    },
  }
}
